import { ContentTypeFilterClause, MixedContentItemDefinition, SpaceDefinition } from './ContentDefinitionsTypes';
import { Messages } from '../../../codegen/Localize';
import { ViewContentType } from '../ContentTypes';
import { getGenericDefaultFilters } from './getDefaultFilters';
import { ViewCard } from '../../../app/spaces/CardView/ViewCard';
import { imgPath } from '../../../common/utilities/ImgUrl';
import { ServerFilterClauses } from '../../helpers/ServerFilterClauses';
import { SpacesSiteUrls } from '../../../app/spaces/SpacesSiteUrls';
import { Views } from '../../../views/resources/Views';
import { IContentInfo } from '../IContentInfo';
import { call } from 'redux-saga/effects';
import { getViewInfos } from '../../../app/sagas/spaces/SpacesSagaHelpers';

export const ViewDefinition: MixedContentItemDefinition & SpaceDefinition<'view'> = {
  itemType: 'view',
  contentType: 'view',
  singularName: Messages.view,
  pluralName: Messages.views,
  emptyStateMessage: Messages.viewsEmptyMessage,
  siteFilterByTypeDropdownName: Messages.siteFilterByTypeDropdown_Views,
  contentFilterKeys: ViewContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: ViewCard,
  listViewIconUrl: imgPath('view_18px-large.svg'),
  filterClause: ServerFilterClauses.ContentType(['view']) as ContentTypeFilterClause,
  contentSpaceUrl: (urls: SpacesSiteUrls, contentId: string) => urls.redirectToViewUrl(contentId),
  getBasicQuery: () => {
    return Views.all().withExtraParams(ViewContentType.extraQueryParams);
  },
  fieldValueResourceType: 'view',
  getContentInfo: (contentList: IContentInfo[]) => call(getViewInfos, contentList),
  headerIconPath: undefined,
  supportedDisplayModes: ['list', 'thumbnail'],
};
